import React,{useState,useEffect} from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ToolTip from '@mui/material/Tooltip';
import FilterListIcon from '@mui/icons-material/FilterList';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import ListIcon from '@mui/icons-material/List';
import PieChartIcon from '@mui/icons-material/PieChart';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import Snackbar from '@mui/material/Snackbar';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import AccessLogSelectors from './AccessLogSelectors';
import AccessLogFilterSelectors from './AccessLogFilterSelectors';
import AccessLogRadar from './AccessLogRadar';
import {FilterValue, FilterItem, resolveSummaryKey} from './AccessLogSelectors';
import chartItemName from './ChartItemName';
import {getSummaryName} from './ChartSummaryName';
import {Owner,Item,AccessLogSummary,AccessLogType} from './Inc';
import Ajax from './Ajax';
import useStyles from './Styles';
import Title from './Title';
import StoreImg from './StoreImg';

interface scoreKey {
	key: string;
	name: string;
}

interface TopAccessLogsProps {
	owner:Owner,
}

const chartColors = [
	"#82ca9d", "#ca9d82", "#8282ca", "#ca8282",
	"#caca82", "#82caca", "#ca82ca", "#6699cc",
	"#cc9966", "#99cc66"
];

const TopAccessLogs:React.FC<TopAccessLogsProps> = (props)=> {
	const classes = useStyles();
	const [conditions,setConditions] = useState({
		period: "24h",
		type: "page",
		interval: "1h",
		filters: {
			items: {},
			summarys: {},
		}
	} as FilterValue);
	const [states,setStates] = useState({
		list:[] as AccessLogType[],
		total:[] as AccessLogType[],
		chart:[] as any[],
		items:[] as Item[],//指定範囲のログに存在する全商品（フィルタの選択に使う）
		summarys:[] as AccessLogSummary[],//指定範囲のログに存在する全リファラ（同）※商品絞り込み後
		allSummarys:[] as AccessLogSummary[],//指定範囲のログに存在する全リファラ（同）※商品絞り込みなし
		scoreKeys:[] as scoreKey[],//チャートに表示する項目のキー
		summaryBank:{} as {[key:string]:string},//summaryがURLの場合にURLキーを割り振るための辞書
		max:50,//チャートの最大値
		itemCount: 0,//合計（未使用）
	});
	const [isLoading, setIsLoading] = useState(false);
	const [isFilterSelectorOpen, setIsFilterSelectorOpen] = useState(false);
	const [summaryChartItemId, setSummaryChartItemId] = useState<number | null>(null);
	const [snack,setSnack] = useState("");
	const theme = useTheme();
	const tooltip = !useMediaQuery(theme.breakpoints.down('md'));

	const openFilterSelector = ()=>{
		if( states.list.length===0 ){
			setSnack("アクセスログがありません");
			return;
		}
		setIsFilterSelectorOpen(true);
	}

	const closeFilterSelector = (newFilterItems: {[key:string]:FilterItem},newFilterSummarys: {[key:string]:FilterItem})=>{
		//console.log("close", newFilterItems, newFilterSummarys);
		setIsFilterSelectorOpen(false);
		setConditions({
			...conditions,
			filters: {
				items: newFilterItems,
				summarys: newFilterSummarys,
			}
		});
	}

	const reload = (newValue: FilterValue)=>{
		setConditions(newValue);
	}
	const convSummary = (summary:string)=>{
		if( summary==="internal" ) return "架空ストア内";
		if( summary==="redirect" ) return "旧URLから転送";
		return summary;
	}
	const openSummaryChart = (itemId:number)=>{
		console.log("open summary chart", itemId);
		setSummaryChartItemId(itemId);
	}
	const closeSummaryChart = ()=>{
		setSummaryChartItemId(null);
	}
	const closeSnack = ()=>{
		setSnack("");
	}


    // const resolveSummaryKey = (
    //     summary: string | undefined,
    //     bank: {[key:string]: string},
    //     createIfMissing: boolean
    // ): { summaryKey: string; summaryValue: string } | null => {
    //     const summaryValue = summary ?? "";
    //     let summaryKey = summary && summary!=="" ? summary : "none";

    //     if (summaryValue.startsWith("http://") || summaryValue.startsWith("https://")) {
    //         const existingKey = Object.keys(bank).find((k) => bank[k] === summaryValue);
    //         if (existingKey) {
    //             summaryKey = existingKey;
    //         } else if (createIfMissing) {
    //             const urlCount = Object.keys(bank).length + 1;
    //             summaryKey = `URL${urlCount}`;
    //             bank[summaryKey] = summaryValue;
    //         } else {
    //             return null;
    //         }
    //     }

    //     return { summaryKey, summaryValue };
    // };

	const convList = (rares:any[])=>{
		const totalBank = {} as {[key:string]:AccessLogType};
		const chartBank = {} as {[key:string]:any};
		const summaryBank = {...states.summaryBank} as {[key:string]:string};

		const list = [] as AccessLogType[];
		const items = [] as Item[];
		const summarys = [] as AccessLogSummary[];
		const allSummarys = [...states.allSummarys] as AccessLogSummary[];
		const scoreKeys = [] as scoreKey[];

		let itemCount = 0;
		let max = 0;

		scoreKeys.push({key: "I_0", name: "商品合計"} as scoreKey);
		totalBank["O_0"] = {
			view_type: "O",
			item_id: 0,
			summary: "",
			access_time: "",
			item_name: "",
			page_name: "",
			img_id: 0,
			count: 0,
		} as AccessLogType;
		totalBank["I_0"] = {
			view_type: "I",
			item_id: 0,
			summary: "",
			access_time: "",
			item_name: "",
			page_name: "",
			img_id: 0,
			count: 0,
		} as AccessLogType;

		for( let data of rares ){
			list.push({
				view_type: data.view_type,
				item_id: Number(data.item_id),
				summary: data.summary,
				log_date: data.log_date ?? "",
				access_time: data.access_time ?? "",
				item_name: data.item_name,
				page_name: data.page_name,
				img_id: Number(data.img_id),
				count: Number(data.ct) || 0,
			} as AccessLogType);

			if( data.item_id && Number(data.item_id)>0 && !items.find(x=>x.item_id===Number(data.item_id)) ){
				items.push({
					item_id: Number(data.item_id),
					item_name: data.item_name,
					page_name: data.page_name,
					img_id: Number(data.img_id),
				} as Item);
			}

			// let summaryKey = data.summary ?? "none";
			// let summaryValue = data.summary ?? "";

			// // summaryValueがURLの場合、summaryBankの要素のうちvalueがsummaryValueに一致するものを探し、そのkeyを返す
			// if( summaryValue.startsWith("http://") || summaryValue.startsWith("https://") ){
			// 	const existingKey = Object.keys(summaryBank).find(key => summaryBank[key] === summaryValue);
			// 	if (existingKey) {
			// 		summaryKey = existingKey;
			// 	} else {
			// 		const urlCount = Object.keys(summaryBank).length + 1;
			// 		summaryKey = `URL${urlCount}`;
			// 		summaryBank[summaryKey] = summaryValue;
			// 	}
			// }

			const resolved = resolveSummaryKey(data.summary, summaryBank, true);
			if (!resolved) continue;
			const { summaryKey, summaryValue } = resolved;

			const scoreKey = `${data.view_type}_${data.item_id ?? 0}` as string;
			let itemOK = false;
			let summaryOK = false;
			if( Object.keys(conditions.filters.items).length===0 || conditions.filters.items[scoreKey] || conditions.filters.items["I_0"] ){
				itemOK = true;
			}
			if( Object.keys(conditions.filters.summarys).length===0 || conditions.filters.summarys[summaryKey] ){
				summaryOK = true;
			}

			// scoreKeysにscoreKeyがない場合は追加する
			// scoreKeysはフィルタに関係なくログに存在する全商品
			if( !scoreKeys.find(x=>x.key===scoreKey) ){
				scoreKeys.push({key: scoreKey, name: chartItemName(data)} as scoreKey);
			}

			// summarysは商品フィルタの影響を受ける
			if( itemOK ){
				const summary = summarys.find(x=>x.value===summaryValue);
				if( !summary ){
					summarys.push({
						key: summaryKey,
						value: summaryValue,
					} as AccessLogSummary);
				}
			}

			// allSummarysは商品フィルタを無視する
			const allSummary = allSummarys.find(x=>x.value===summaryValue);
			if( !allSummary ){
				allSummarys.push({
					key: summaryKey,
					value: summaryValue,
				} as AccessLogSummary);
			}

			//console.log(data.item_id, scoreKey, summaryKey, itemOK, summaryOK);
			if( itemOK && summaryOK ){
				// conditions.filters.itemsが空か、またはscoreKeyがconditions.filters.itemsに含まれている場合のみtotalBankに追加する
				if( !totalBank[scoreKey] ){
					totalBank[scoreKey] = {
						view_type: data.view_type,
						item_id: Number(data.item_id),
						summary: "",
						access_time: "",
						item_name: data.item_name,
						page_name: data.page_name,
						img_id: data.img_id ? Number(data.img_id) : 0,
						count: 0,
					} as AccessLogType;
				}

				// conditions.filters.summarysが空か、またはdata.summaryがconditions.filters.summarysに含まれている場合のみ集計する
				const ct = Number(data.ct);
				if( ct ){
					totalBank[scoreKey].count += ct;
					if( totalBank[scoreKey].access_time==="" || totalBank[scoreKey].access_time < data.log_date ){
						totalBank[scoreKey].access_time = data.log_date;
						totalBank[scoreKey].summary = data.summary;
					}

					if( data.view_type==="I" ){
						totalBank["I_0"].count += ct;
						itemCount += ct;
					}
				}
			}
		}

		if( conditions.period==="24h" ){
			// 1時間ごとに過去24時間分のデータを用意する
			// key = `${year}_${month}_${day}_${hour}` as string;
			for( let i=0; i<25; i++ ){
				const date = new Date();
				date.setHours(date.getHours() - i);
				const year = date.getFullYear();
				const month = (date.getMonth()+1).toString().padStart(2, '0');
				const day = date.getDate().toString().padStart(2, '0');
				const hour = date.getHours().toString().padStart(2, '0');
				const key = `${year}_${month}_${day}_${hour}` as string;
				if( !chartBank[key] ){
					chartBank[key] = {} as any;
					//chartBank[key].name = `${Number(hour)}時`;
					chartBank[key].name = `${Number(hour)}`;

					for( let sk of scoreKeys ){
						chartBank[key][sk.key] = 0;
					}
				}
			}
        } else if( conditions.interval==="1d" && (conditions.period==="7d" || conditions.period==="28d") ){
            // 1日ごとにデータを用意する（当日含む）
            const range = conditions.period==="7d" ? 8 : 29;

            for( let i=0; i<range; i++ ){
                const date = new Date();
                date.setDate(date.getDate() - i);
                const year = date.getFullYear();
                const month = (date.getMonth()+1).toString().padStart(2, '0');
                const day = date.getDate().toString().padStart(2, '0');
                const key = `${year}_${month}_${day}` as string;

                if( !chartBank[key] ){
                    chartBank[key] = {} as any;
                    chartBank[key]["name"] = `${month}/${day}`;
                    for( let sk of scoreKeys ){
                        chartBank[key][sk.key] = 0;
                    }
                }
            }
		} else if( conditions.interval==="1w" && (conditions.period==="28d" || conditions.period==="3m") ){
			// 1週間ごとにデータを用意する（当日含む）
			// 1週間の区切りは日曜日
			const base = new Date();
			base.setHours(0, 0, 0, 0);
			base.setDate(base.getDate() - base.getDay() + 1); // 直近の月曜

			const range = conditions.period==="28d" ? 5 : 13;
			for( let i=0; i<range; i++ ){
				const date = new Date(base);
				date.setDate(base.getDate() - i*7);
				const year = date.getFullYear();
				const month = (date.getMonth()+1).toString().padStart(2, '0');
				const day = date.getDate().toString().padStart(2, '0');

				const key = `${year}_${month}_${day}` as string;
				if( !chartBank[key] ){
					chartBank[key] = {} as any;
					chartBank[key].name = `${month}/${day}`;
					for( let sk of scoreKeys ){
						chartBank[key][sk.key] = 0;
					}
				}
			}
		} else if( conditions.interval==="1m" && (conditions.period==="3m" || conditions.period==="1y") ){
			// 1カ月ごとにデータを用意する（当日含む）
			const base = new Date();
			base.setHours(0, 0, 0, 0);
			base.setDate(1); // 直近の月初
			const range = conditions.period==="3m" ? 4 : 13;
			for( let i=0; i<range; i++ ){
				const date = new Date(base);
				date.setMonth(base.getMonth() - i);
				date.setDate(1);
				const year = date.getFullYear();
				const month = (date.getMonth()+1).toString().padStart(2, '0');
				//const day = date.getDate().toString().padStart(2, '0');
				const key = `${year}_${month}` as string;
				if( !chartBank[key] ){
					chartBank[key] = {} as any;
					chartBank[key].name = `${month}`;
					for( let sk of scoreKeys ){
						chartBank[key][sk.key] = 0;
					}
				}
			}
        }

		for( let data of rares ){
			//チャート
			// data.monthとdata.hourはゼロ埋めされていないため、1桁の場合は0を付与する
			//const month = Number(data.log_date).toString().padStart(2, '0');
			//console.log(data);
			const date = new Date(data.log_date);
			//const month = (date.getMonth()+1).toString().padStart(2, '0');
			const year = date.getFullYear();
			const month = (date.getMonth()+1).toString().padStart(2, '0');
			let key = '' as string;
			if( conditions.interval==="1m" ){
				key = `${year}_${month}` as string;
			} else if( conditions.interval==="1w" ){
				const day = date.getDate().toString().padStart(2, '0');
				//const week = Number(data.week).toString().padStart(2, '0');
				key = `${year}_${month}_${day}` as string;
			} else {
				//const day = Number(data.day).toString().padStart(2, '0');
				const day = date.getDate().toString().padStart(2, '0');
				if( conditions.interval==="1h" ){
					//const hour = Number(data.hour).toString().padStart(2, '0');
					const hour = date.getHours().toString().padStart(2, '0');
					key = `${year}_${month}_${day}_${hour}` as string;
				} else if( conditions.interval==="1d" ){
					key = `${year}_${month}_${day}` as string;
				}
			}

			const scoreKey = `${data.view_type}_${data.item_id ?? 0}` as string;

			// let summaryKey = data.summary ?? "none";
			// let summaryValue = data.summary ?? "";

			// // summaryValueがURLの場合、summaryBankの要素のうちvalueがsummaryValueに一致するものを探し、そのkeyを返す
			// if( summaryValue.startsWith("http://") || summaryValue.startsWith("https://") ){
			// 	const existingKey = Object.keys(summaryBank).find(key => summaryBank[key] === summaryValue);
			// 	if (existingKey) {
			// 		summaryKey = existingKey;
			// 	} else {
			// 		continue;
			// 	}
			// }

			const resolved = resolveSummaryKey(data.summary, summaryBank, false);
			if (!resolved) continue;
			const { summaryKey } = resolved;

			let itemOK = false;
			let summaryOK = false;
			if( Object.keys(conditions.filters.items).length===0 || conditions.filters.items[scoreKey]  || conditions.filters.items["I_0"] ){
				itemOK = true;
			}
			if( Object.keys(conditions.filters.summarys).length===0 || conditions.filters.summarys[summaryKey] ){
				summaryOK = true;
			}

			if( itemOK && summaryOK ){
				if( chartBank[key][scoreKey]!==undefined ){
					if( data.ct ){
						chartBank[key][scoreKey] += Number(data.ct);
					} else {
						chartBank[key][scoreKey] ++;
					}
					if( max<chartBank[key][scoreKey] ){
						max = chartBank[key][scoreKey];
					}
				}
				if( data.view_type==="I" ){
					if( chartBank[key]["I_0"]!==undefined ){
						if( data.ct ){
							chartBank[key]["I_0"] += Number(data.ct);
						} else {
							chartBank[key]["I_0"] ++;
						}
					}
					if( max<chartBank[key]["I_0"] ){
						max = chartBank[key]["I_0"];
					}
				}
			}
		}

		//console.log("chartBank", chartBank);

		// totalBankをcountの降順でソート
		const total = Object.values(totalBank).sort((a,b)=>b.count-a.count);
		// chartBankをkeyの昇順でソート
		const chart = Object.keys(chartBank).sort().map(key=>chartBank[key]);
		// summarysをkeyの昇順でソート
		summarys.sort((a,b)=>{
			if( a.key < b.key ) return -1;
			if( a.key > b.key ) return 1;
			return 0;
		});
		allSummarys.sort((a,b)=>{
			if( a.key < b.key ) return -1;
			if( a.key > b.key ) return 1;
			return 0;
		});

		return {list:list, total:total, chart:chart, scoreKeys:scoreKeys, items:items, summarys:summarys, summaryBank:summaryBank, itemCount:itemCount, max:max, allSummarys:allSummarys};
	}

	const removeItemFilter = (filter:string)=>{
		// conditions.filters.itemsからfilterを除外する
		const newItems = Object.keys(conditions.filters.items).filter(key=>key!==filter).reduce((obj, key) => {
			obj[key] = conditions.filters.items[key];
			return obj;
		}, {} as {[key:string]:FilterItem});
		setConditions({...conditions, filters: {...conditions.filters, items: newItems}});
	}
	const removeSummaryFilter = (filter:string)=>{
		// conditions.filters.summarysからfilterを除外する
		console.log("remove summary filter", filter);
		const newSummaryFilters = Object.keys(conditions.filters.summarys).filter(key=>key!==filter).reduce((obj, key) => {
			obj[key] = conditions.filters.summarys[key];
			return obj;
		}, {} as {[key:string]:FilterItem});
		setConditions({...conditions, filters: {...conditions.filters, summarys: newSummaryFilters}});
	}

	const refresh = (list:any[])=>{
		const result = convList(list);
		let max = 0;
		//console.log(result);
		if( result["max"] ){
			if( result["max"]>100 ){
				max = Math.ceil(result["max"]*1.1/100)*100;
			} else if( result["max"]>50 ){
				max = Math.ceil(result["max"]*1.1/10)*10;
			} else if( result["max"]>10 ){
				max = Math.ceil(result["max"]*1.2/5)*5;
			} else {
				max = Math.ceil(result["max"]*1.2);
			}
		}
		setStates(prev=>({
			...prev,
			list: result["list"],
			total: result["total"],
			chart: result["chart"],
			items: result["items"],
			summarys: result["summarys"],
			summaryBank: result["summaryBank"],
			allSummarys: result["allSummarys"],
			scoreKeys: result["scoreKeys"],
			itemCount: result["itemCount"],
			max: max,
		}));
	}

	useEffect( ()=>{
		console.log("top:effect");
		window.scrollTo(0,0);

		if( props.owner.owner_id>0 ){
			//console.log("start",props.owner.owner_id);
			//setStates({...states,"isLoading":true});
			setIsLoading(true);
			Ajax.setEditorId(props.owner.owner_id);
			//Ajax.setEditorId(650);
			Ajax.send("top/log",{...conditions},(res:any)=>{
				//console.log("stop",props.owner.owner_id,res);
				if( res.ok ){
					//console.log(res.list);
					refresh(res.list);
					setIsLoading(false);
				} else {
					//setStates({...states,"isLoading":false});
					setIsLoading(false);
				}
			});
		} else {

		}
	},[props.owner.owner_id, conditions]);


	return (
		<>
		<Box style={{marginBottom:"4em"}}>
			<Title text="アクセスログ"/>
			<AccessLogRadar
				open={summaryChartItemId!==null}
				onClose={closeSummaryChart}
				itemId={summaryChartItemId ?? 0}
				conditions={conditions}
				summaryBank={states.summaryBank}
				list={states.list}
			/>
			<AccessLogSelectors value={conditions} onChange={reload} />
			<AccessLogFilterSelectors
				owner={props.owner}
				open={isFilterSelectorOpen}
				onClose={closeFilterSelector}
				filters={conditions.filters}
				items={states.items}
				summarys={states.summarys}
				allSummarys={states.allSummarys}
			/>
			<ResponsiveContainer width="100%" aspect={1.618} maxHeight={500}>
				<LineChart
					width={500}
					height={300}
					data={states.chart}
					margin={{
						top: 5,
						right: 0,
						left: 0,
						bottom: 5,
					}}
				>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis dataKey="name"/>
					<YAxis domain={[0, states.max]} allowDecimals={false} mirror={true}/>
					<Tooltip
						cursor={{
							stroke: 'var(--color-border-2)',
						}}
						contentStyle={{
							backgroundColor: 'white',
							borderColor: '#CCCCCC',
						}}
						active={tooltip ? undefined : false}
					/>
					{Object.keys(conditions.filters.items).length===0 ? (
					<>
					<Line type="monotone" dot={false} name={"作家"} dataKey={"O_0"} stroke={chartColors[0]} strokeWidth={2} isAnimationActive={true}/>
					<Line type="monotone" dot={false} name={"商品合計"} dataKey={"I_0"} stroke={chartColors[1]} strokeWidth={2} isAnimationActive={true}/>
					</>
					):(
                    <>
                    {Object.keys(conditions.filters.items).map((key, i) => {
                        const filter = conditions.filters.items[key];
                        const sk = filter ? states.scoreKeys.find(scoreKey => scoreKey.key === filter.key) : undefined;
                        return sk ? (
                            <Line key={key} type="monotone" dot={false} name={sk.name} dataKey={filter.key} stroke={chartColors[i]} strokeWidth={2} isAnimationActive={true}/>
                        ) : null;
                    })}
                    </>
					)}
				</LineChart>
			</ResponsiveContainer>

			<Box sx={{marginTop:"1rem"}}>
				<FormControl component="fieldset" variant="standard" fullWidth style={{backgroundColor:"#F9F9F9"}}>
					<FormGroup row sx={{gap:"0.5rem", padding:'1rem 1rem', justifyContent:'center', '& .MuiFormControlLabel-label': { fontSize: { xs: '0.75rem', sm: '0.85rem' } },}}>
						{Object.keys(conditions.filters.items).length===0 ? (
						<>
						<Button style={{padding:"0 1rem",margin:'0',fontSize:"0.8rem",color:chartColors[0]}} startIcon={<ShowChartIcon sx={{ width: { xs: '0.8rem', sm: '1rem' } }} />} disabled={true}>作家</Button>
						<Button style={{padding:"0 1rem",margin:'0',fontSize:"0.8rem",color:chartColors[1]}} startIcon={<ShowChartIcon sx={{ width: { xs: '0.8rem', sm: '1rem' } }} />} disabled={true}>商品合計</Button>
						</>
						):(
						<>
						{Object.keys(conditions.filters.items).map((key, i) => {
							const hasScoreKey = states.scoreKeys.some((scoreKey) => scoreKey.key === key);
							return (
								<Button
									key={i}
									sx={{
										padding: "0rem 1rem",
										margin: '0',
										fontSize: "0.8rem",
										color: hasScoreKey ? chartColors[i] : "#ccc",
										width: {xs:'100%', sm:'auto'},
										justifyContent: {xs:'flex-start', sm:'center'},
										textAlign: {xs:'left', sm:'center'},
									}}
									startIcon={<ShowChartIcon sx={{ width: { xs: '0.8rem', sm: '1rem' } }} />}
									onClick={() => removeItemFilter(key)}
								>
									{conditions.filters.items[key].name}
								</Button>
							);
						})}
						</>
						)}
					</FormGroup>
				</FormControl>
				{Object.keys(conditions.filters.summarys).length>0 &&
				<FormControl component="fieldset" variant="standard" fullWidth style={{backgroundColor:"#F9F9F9"}}>
					<FormGroup row sx={{gap:"0.5rem", paddingBottom:'1rem', justifyContent:'center', width:'100%', '& .MuiFormControlLabel-label': { fontSize: { xs: '0.75rem', sm: '0.85rem' } },}}>
						{Object.keys(conditions.filters.summarys).map((key, i) => {
							const hasSummaryKey = states.summarys.some((summary) => summary.key === key);
							return (
								<Button
									key={i}
									style={{
										padding: "0 0.5rem",
										margin: '0',
										fontSize: "0.7rem",
										textTransform: "none",
										color: hasSummaryKey ? "teal" : "#ccc",
									}}
									startIcon={<QueryStatsIcon sx={{ width: { xs: '0.8rem', sm: '1rem' } }} />}
									onClick={() => removeSummaryFilter(key)}
								>
									{conditions.filters.summarys[key].name}
								</Button>
							);
						})}
					</FormGroup>
				</FormControl>
				}
				<Box sx={{marginTop:"1rem", display:'flex', justifyContent:'center', width:'100%'}}>
					<Button
						variant="contained"
						size="small"
						startIcon={
							<FilterListIcon sx={{ width: { xs: '0.8rem', sm: '1rem' } }} />
						}
						onClick={openFilterSelector}
						disabled={states.list.length===0}
					>フィルタ追加</Button>
				</Box>
			</Box>

			{conditions.period==='24h' && states.list.length>0 &&
			<Box sx={{marginTop:"2rem"}}>
				<Box sx={{marginBottom:'0.1rem',paddingBottom:'0.5rem',borderBottom:'1px solid #ccc',display:'flex',alignItems:'center',gap:'0.5rem'}}><ListIcon/>24Hログ（リファラとアクセス日時）</Box>
				<Table>
					<TableBody>
				{states.list.map((log:any,idx:number)=>{
					const key = "list_"+idx;

					if( Object.keys(conditions.filters.items).length>0 ){
						const scoreKey = `${log.view_type}_${log.item_id ?? 0}` as string;
						if( !conditions.filters.items.hasOwnProperty(scoreKey) ){
							return null;
						}
					}
					if( Object.keys(conditions.filters.summarys).length>0 ){
						let value = log.summary ?? "";
						const summaryKey = states.summarys.find((s:any)=>s.value===value)?.key ?? "";
						if( !conditions.filters.summarys.hasOwnProperty(summaryKey) ){
							return null;
						}
					}

					return (
						<TableRow key={key}>
							<TableCell className={classes.tableCellDense} align="center" sx={{width:"1px",whiteSpace:"nowrap"}}><StoreImg owner_id={props.owner.owner_id} img_id={log.view_type==="O" ? props.owner.img_id : log.img_id} thumb={true} className="imgList"/></TableCell>
							{log.view_type==="O" ? (
							<TableCell className={classes.tableCellDense} sx={{fontSize:{xs:'0.8rem',sm:'0.9rem'}}}>
								<a
									href={`https://store.retro-biz.com/items/owner/${props.owner.owner_id}`}
									style={{color:'#333333'}}
									target="_blank" rel="noopener noreferrer">
									<span style={{display:'block',fontSize:'0.8rem',color:'teal'}}>作家</span>
									<span>{props.owner.owner_name}</span>
								</a>
							</TableCell>
							):(
							<TableCell className={classes.tableCellDense}sx={{fontSize:{xs:'0.8rem',sm:'0.9rem'}}}>
								<span className={classes.itemId}>ID:{log.item_id}</span>
								<Box sx={{lineHeight:'1.3',margin:'0',marginTop:'0.2rem',fontSize:{xs:'0.8rem',sm:'0.9rem'}}}>
									<a
										href={`https://store.retro-biz.com/items/${log.item_id}`}
										style={{color:'#333333'}}
										target="_blank"
										rel="noopener noreferrer">
										<span>{chartItemName(log)}</span>
									</a>
								</Box>
								{log.summary && log.summary!=='' &&
								<Box sx={{color:'teal',padding:'0',margin:'0'}}>
									{log.summary.startsWith('https://') ? (
										<a
											href={log.summary}
											target="_blank"
											rel="noopener noreferrer"
											style={{
												display:'-webkit-box',
												WebkitBoxOrient:'vertical',
												WebkitLineClamp:2,
												overflow:'hidden',
												textOverflow:'ellipsis',
												wordBreak:'break-all',
												textAlign:'left',
												color:'teal',
											}}
										>{log.summary} から</a>
									) : (
										<span
											style={{
												display:'-webkit-box',
												WebkitBoxOrient:'vertical',
												WebkitLineClamp:2,
												overflow:'hidden',
												textOverflow:'ellipsis',
												wordBreak:'break-all',
												textAlign:'left',
											}}
										>
											{getSummaryName(log.summary)} から
										</span>
									)}
								</Box>}
							</TableCell>
							)}
							<TableCell className={classes.tableCellDense} align="center" sx={{width:"1px",textAlign:"right",color:'#666666',fontSize:{xs:'0.8rem',sm:'0.9rem'}}}>
								{log.access_time}
							</TableCell>
						</TableRow>
					)
				})}
					</TableBody>
				</Table>
			</Box>
			}

			{conditions.period!=='24h' && states.list.length>0 &&
			<Box sx={{marginTop:"2rem"}}>
				<Box sx={{marginBottom:'0.1rem',paddingBottom:'0.5rem',borderBottom:'1px solid #ccc',display:'flex',alignItems:'center',gap:'0.5rem'}}><ListIcon/>集計結果</Box>
				<Table>
					<TableBody>
						<TableRow key="O_0">
							<TableCell className={classes.tableCellDense} align="center" sx={{width:"1px",whiteSpace:"nowrap"}}><StoreImg owner_id={props.owner.owner_id} img_id={props.owner.img_id} thumb={true} className="imgList"/></TableCell>
							<TableCell className={classes.tableCellDense} sx={{fontSize:{xs:'0.8rem',sm:'0.9rem'}}}>
								<span style={{display:'block',fontSize:'0.8rem',color:'teal'}}>作家</span>
								<span>{props.owner.owner_name}</span>
							</TableCell>
							<TableCell className={classes.tableCellDense} align="center" style={{width:"1px",whiteSpace:"nowrap",textAlign:"center",color:'teal'}}>
								<ToolTip title="リファラの集計を円グラフで表示">
									<Button style={{flexDirection:'column',padding:'0',minWidth:0,width:'auto',margin:'0'}} onClick={()=>openSummaryChart(-1)}>
										{states.total.find((item:any)=>item.view_type==="O" && item.item_id===0)?.count ?? 0}<br/>
										<PieChartIcon/>
									</Button>
								</ToolTip>
							</TableCell>
						</TableRow>
						<TableRow key="I_0">
							<TableCell className={classes.tableCellDense} align="center" sx={{width:"1px",whiteSpace:"nowrap",borderBottom:'2px solid teal'}}><StoreImg owner_id={props.owner.owner_id} img_id={props.owner.img_id} thumb={true} className="imgList"/></TableCell>
							<TableCell className={classes.tableCellDense} sx={{fontSize:{xs:'0.8rem',sm:'0.9rem'},borderBottom:'2px solid teal'}}>
								商品合計
							</TableCell>
							<TableCell className={classes.tableCellDense} align="center" style={{width:"1px",whiteSpace:"nowrap",textAlign:"center",color:'teal',borderBottom:'2px solid teal'}}>
								<ToolTip title="リファラの集計を円グラフで表示">
									<Button style={{flexDirection:'column',padding:'0',minWidth:0,width:'auto',margin:'0'}} onClick={()=>openSummaryChart(0)}>
										{states.total.find((item:any)=>item.view_type==="I" && item.item_id===0)?.count ?? 0}<br/>
										<PieChartIcon/>
									</Button>
								</ToolTip>
							</TableCell>
						</TableRow>
				{states.total.map((log:any,idx:number)=>{
					const key = "total_"+idx;
					if( log.view_type==="O" || log.item_id===0 ) return null;
					return (
						<TableRow key={key}>
							<TableCell className={classes.tableCellDense} align="center" sx={{width:"1px",whiteSpace:"nowrap"}}><StoreImg owner_id={props.owner.owner_id} img_id={log.img_id} thumb={true} className="imgList"/></TableCell>
							<TableCell className={classes.tableCellDense}sx={{fontSize:{xs:'0.8rem',sm:'0.9rem'}}}>
								<span className={classes.itemId}>ID:{log.item_id}-{log.img_id}</span>
								<p style={{lineHeight:'1.3',margin:'0',marginTop:'0.2rem'}}>{chartItemName(log)}</p>
							</TableCell>
							<TableCell className={classes.tableCellDense} align="center" style={{width:"1px",whiteSpace:"nowrap",textAlign:"center",color:'teal'}}>
								<ToolTip title="リファラの集計を円グラフで表示">
									<Button style={{flexDirection:'column',padding:'0',minWidth:0,width:'auto',margin:'0'}} onClick={()=>openSummaryChart(log.item_id)}>
										{log.count}<br/>
										<PieChartIcon/>
									</Button>
								</ToolTip>
							</TableCell>
						</TableRow>
					)
				})}
					</TableBody>
				</Table>
			</Box>
			}
			<Box sx={{marginTop:"2rem",padding:"2rem",fontSize:"0.9rem",backgroundColor:"#f1f2f3",borderRadius:"0.5rem"}}>
				<ul style={{margin:'0',paddingLeft:'1.2em'}}>
					<li style={{marginBottom:"0.75rem"}}>botやクローラーを除外する処理の都合により、現在日時から5分以内のログは集計に含まれません</li>
					<li style={{marginBottom:"0.75rem"}}>作家さんがログインした状態で自分のページにアクセスした場合はログに記録されません</li>
					<li style={{marginBottom:"0.75rem"}}>リファラは2026年4月20日から記録しています</li>
					<li style={{marginBottom:"0.75rem"}}>画面は自動更新されませんので、最新の内容に更新したい場合は期間などを変更してみてください</li>
				</ul>
			</Box>
		</Box>
		<Snackbar
			anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
			open={snack!==""}
			autoHideDuration={5000}
			onClose={closeSnack}
			message={snack}
		/>
		</>
	);
}

export default TopAccessLogs;
